import { ButtonV2 } from 'components';
import Program from 'models/Program';
import React from 'react';

interface Step3Props {
  program: Program;
  onClose: (program: Program | null) => void;
}

const Step3: React.FC<Step3Props> = ({ program, onClose }) => {
  return (
    <div className="modal__wrapper">
      <div className="modal__header step-3">
        <span className="modal__header-title success-title">Program Successfully Created</span>
      </div>
      <div className="modal__container">
        <div className="success-image">
          <img src="/assets/images/programs-success.png" />
        </div>
        <div className="success-message">
          Your program was successfully created. Click Continue to enroll students and assign staff to this program.
        </div>
        <div className="form__row form__row--actions">
          <ButtonV2 data-cy="cancel" secondary label="Close" onClick={() => onClose(program)} />
          <ButtonV2 data-cy="next" label="Continue" onClick={() => alert('Next steps are in a separate story.')} />
        </div>
      </div>
    </div>
  );
};

export default Step3;
